<template>
  <div>
        <PricingFilterToolbar
          :search-term="searchTerm"
          :expired-filter="expiredFilter"
          search-placeholder="Search (Description, Domain)..."
          @search-change="searchTerm = $event"
          @expired-filter-change="expiredFilter = $event"
        >
          <template v-slot:actions>
            <button
              v-if="userEditRight"
              class="btn btn-success mr-3 mb-2"
              @click="addNewPackage()"
              type="button"
            >
              New Domain Package
            </button>
          </template>
        </PricingFilterToolbar>
        <div class="row row-spacing">
            <div class="col-md-12">
                <div class="table-responsive table-bordered" v-if="packages.length > 0">
                    <table class="table pricing-table">
                        <thead>
                            <tr>
                                <th class="pricing-column-description">Description</th>
                                <th class="pricing-column-domain" style="text-align:center">Domain</th>
                                <th class="pricing-column-label">Supplier</th>
                                <th class="pricing-column-price">Price (excl. VAT)</th>
                                <th class="pricing-column-term">Contract Term</th>
                                <th class="pricing-column-term">Billing</th>
                                <th class="pricing-column-status">Expired</th>
                                <th class="pricing-column-actions"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr :class="{'row-expired' : p.expired}" v-for="p in packages" :key="p.domainRegistrationPackageNumber">
                                <td>{{ p.description }}</td>
                                <td class="text-center">
                                    <span class="badge badge-primary">
                                        <strong>
                                            .{{ p.topLevelDomain }}
                                        </strong>
                                    </span>
                                </td>
                                <td>{{ p.supplier }}</td>
                                <td>
                                    {{
                                        getCurrencyPrice(
                                        p.domainregistrationpackageprices,
                                        getCurrentPeriod(),
                                        p.currency
                                        )
                                    }}
                                    <span
                                        style="cursor: pointer"
                                        @click="openPriceModal(p)"
                                        v-tooltip="'Edit Price'"
                                        class="pull-right align-self-center"
                                    >
                                        <em class="fa fa-edit fa-fw text-green"></em>
                                    </span>
                                </td>
                                <td>{{ getContractTermLabel(p.contractTerm) }}</td>
                                <td>{{ getBillingFrequencyLabel(p.billingFrequency) }}</td>
                                <td class="text-center">
                                    <span
                                        class="badge"
                                        :class="
                                        p.expired
                                            ? 'badge-warning'
                                            : 'badge-green'
                                        "
                                        >{{ p.expired }}
                                    </span>
                                </td>
                                
                                <td style="text-align:center">
                                    <button
                                        v-tooltip="'Edit Package'"
                                        type="button"
                                        @click="openEditModal(p)"
                                        class="btn btn-sm btn-info m-1"
                                    >
                                        <em class="fa fa-edit fa-fw"></em>
                                    </button>
                                    <button
                                        v-tooltip="'Delete Package'"
                                        type="button"
                                        @click="deletePackage(p.domainRegistrationPackageNumber)"
                                        class="btn btn-sm btn-primary"
                                    >
                                        <em class="fa fa-trash fa-fw"></em>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="alert alert-info">No Domain Registration Packages Available</div>
            </div>
        </div>

        <modal :title="newPackage.objKey ? 'Update Package' : 'Create New Domain Package'" ref="addNewPackage" @save="newPackage.objKey ? updatePackage(newPackage) : createPackage()">
          <div class="row">
            <div class="form-group col-md-6">
              <label>Description</label>
              <input
                disabled
                type="text"
                v-model="newPackage.description"
                class="form-control"
              />
            </div>
            <div class="form-group col-md-6">
              <label>Label</label>
              <input
                type="text"
                v-model="newPackage.label"
                class="form-control"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label>Top Level Domain</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">.</span>
                </div>
                <input
                  type="text"
                  v-model="newPackage.topLevelDomain"
                  class="form-control"
                />
              </div>
            </div>
            <div class="form-group col-md-6">
              <label>Supplier</label>
              <input
                type="text"
                v-model="newPackage.supplier"
                class="form-control"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label>Currency</label>
              <v-select
                :options="currencies"
                placeholder="Select Currency"
                v-model="newPackage.currency"
              ></v-select>
            </div>
            <div class="form-group col-6" v-if="newPackage.objKey">
              <label class="control-label"> Expired </label>
              <v-select :options="['true', 'false']" v-model="newPackage.expired" placeholder="false"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label class="control-label">Contract Term</label>
              <v-select
                ref="contractTermSelect"
                name="Term"
                :options="contractTerms"
                label="label"
                :reduce="term => term.code"
                v-model="newPackage.contractTerm"
                placeholder="Select Term"></v-select>
            </div>
            <div class="form-group col-6">
              <label class="control-label">Billing Frequency</label>
              <v-select
                ref="billingFrequencySelect"
                name="Billing Frequency"
                :options="billingFrequencies"
                label="description"
                :reduce="freq => freq.value"
                v-model="newPackage.billingFrequency"
                placeholder="Select Billing Frequency"></v-select>
            </div>
          </div>
        </modal>
        
        <AddDomainPriceModal
          ref="addDomainPriceModal"
          :row-price="rowPrice"
          :new-price="newPrice"
          :currency="productCurrency"
          @addPrice="addPrice"
          @pricesAdded="getPackages()"
        />
  </div>
</template>

<script>
import AddDomainPriceModal from "@/components/Admin/Modals/AddDomainPriceModal";
import Modal from '@/components/GeneralComponents/Modal';
import PriceFunctions from "@/components/Admin/PriceFunctions";
import PricingFilterToolbar from "@/components/Admin/PricingFilterToolbar";

export default {
extends: PriceFunctions,
  components: {
    Modal,
    AddDomainPriceModal,
    PricingFilterToolbar,
  },
  props: {
    productNumber: {
      type: Number,
      required: true
    },
    userEditRight: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      definition: {},
      allPackages: [],
      newPackage: {},
      newPrice: {},
      rowPrice: [],
      contractTerms: [],
      billingFrequencies: [],
      integrations: ["Manual", "Partial", "Full"],
      currencies: ["ZAR", "USD", "EUR"],
      productCurrency: "",
      expiredFilter: "false",
      searchTerm: "",
    }
  },
  created() {
    this.$root.$emit("SET_PAGE_TITLE", this.$route.meta.title);
  },
  mounted() {
    this.getPackages();
    this.getContractTerms();
    this.getBillingFrequencies();
  },
  computed: {
    packages() {
      let filteredPackages = this.allPackages;

      if (this.expiredFilter === "false") {
        filteredPackages = filteredPackages.filter((pkg) => pkg.expired === false);
      } else if (this.expiredFilter === "true") {
        filteredPackages = filteredPackages.filter((pkg) => pkg.expired === true);
      }

      if (this.searchTerm) {
        const normalizedSearchTerm = this.searchTerm.toLowerCase();
        filteredPackages = filteredPackages.filter((pkg) =>
          [
            pkg.description,
            pkg.label,
            pkg.topLevelDomain,
            this.getContractTermLabel(pkg.contractTerm),
          ]
            .filter(Boolean)
            .some((value) => value.toLowerCase().includes(normalizedSearchTerm))
        );
      }
      return filteredPackages;
    },
  },
  methods: {
      getPackages() {
          this.$http.get(this.$config.aimsAPI + 'pricing/domainregistrationpackages')
          .then(response => {
              this.definition = response.data;
              this.allPackages = response.data.domainregistrationpackages;
              this.newPackage = response.data.domainregistrationpackage;
              this.newPrice = response.data.domainregistrationpackageprice;
          },
          error => {
              this.showError('Error fetching Global Domain Pricing Packages', error)
              console.error(error);
          });
      },
      addNewPackage() {
          this.newPackage = this.definition.domainregistrationpackage;
          this.newPackage.productNumber = this.productNumber;
          if (typeof this.newPackage.contractTerm === 'string' || !this.newPackage.contractTerm) {
            const termCode = this.newPackage.contractTerm || 'MONTH_TO_MONTH';
            this.newPackage.contractTerm = {
              label: this.getContractTermLabel(termCode),
              code: termCode
            };
          }
          if (typeof this.newPackage.billingFrequency === 'string' || !this.newPackage.billingFrequency) {
            const bf = this.newPackage.billingFrequency || 'MONTHLY';
            this.newPackage.billingFrequency = {
              label: this.getBillingFrequencyLabel(bf),
              code: bf
            };
          }
          this.$refs.addNewPackage.open();
      },
      createPackage() {
          this.$refs.addNewPackage.isLoading();
          const packageData = { ...this.newPackage };
          if (typeof packageData.contractTerm === 'object' && packageData.contractTerm !== null) {
            packageData.contractTerm = packageData.contractTerm.code;
          }
          if (typeof packageData.billingFrequency === 'object' && packageData.billingFrequency !== null) {
            packageData.billingFrequency = packageData.billingFrequency.value;
          }
          this.$http
              .post(
                  this.$config.aimsAPI + "pricing/domainregistrationpackages",
                  packageData
              )
              .then(
              (response) => {
                  this.showSuccess("Create Success");
                  this.$refs.addNewPackage.close();

                  const registrationPackage = response.data;
                  registrationPackage.domainregistrationpackageprices = [];
                  this.allPackages.push(registrationPackage);
                  this.openPriceModal(registrationPackage);
              },
              (error) => {
                  console.error(error);
                  this.showError("Error Creating Domain Registration Package", error);
              }
              )
              .finally(() => {
                  this.$refs.addNewPackage.isLoading();
              });
      },
      openEditModal(pack) {
          this.newPackage = this.deepCopyObject(pack);
          if (typeof this.newPackage.contractTerm === 'string') {
            const termCode = this.newPackage.contractTerm;
            this.newPackage.contractTerm = {
              label: this.getContractTermLabel(termCode),
              code: termCode
            };
          }
          if (typeof this.newPackage.billingFrequency === 'string') {
            const bf = this.newPackage.billingFrequency;
            this.newPackage.billingFrequency = {
              description: this.getBillingFrequencyLabel(bf),
              value: bf
            };
          }

          this.$refs.addNewPackage.open();
      },
      updatePackage(pack) {
          const packageData = { ...pack };
          if (typeof packageData.contractTerm === 'object' && packageData.contractTerm !== null) {
            packageData.contractTerm = packageData.contractTerm.code;
          }
          if (typeof packageData.billingFrequency === 'object' && packageData.billingFrequency !== null) {
            packageData.billingFrequency = packageData.billingFrequency.value;
          }

          this.$http.put(this.$config.aimsAPI + "pricing/domainregistrationpackages",
              packageData
              )
              .then(
              () => {
                  this.getPackages();
                  this.showSuccess("Save Success");
                  this.$refs.addNewPackage.close();
              },
              (error) => {
                  console.error(error);
                  this.showError("Error Saving Domain Registration Package", error);
              }
              );
      },
      getContractTerms() {
        const hostUrl = this.$config.aimsAPI;
        this.$http.get(`${hostUrl}pricing/contractterms`).then(
          (response) => {
            this.contractTerms = response.data.map(term => ({
              label: this.getContractTermLabel(term),
              code: term
            }));
          },
          (error) => {
            this.showError("Error fetching Contract Terms", error);
            console.error(error);
          }
        );
      },
      getContractTermLabel(term) {
        const labels = {
          'MONTH_TO_MONTH': 'Month to month',
          'ONE_YEAR': '1 Year',
          'TWO_YEAR': '2 Year',
          'THREE_YEAR': '3 Year',
          'FOUR_YEAR': '4 Year'
        };
        return labels[term] || term;
      },
      getBillingFrequencies() {
        const hostUrl = this.$config.aimsAPI;
        this.$http.get(`${hostUrl}pricing/billingfrequencies`).then(
          (response) => {
            this.billingFrequencies = response.data.map(freq => ({
              description: this.getBillingFrequencyLabel(freq),
              value: freq  
            }));
          },
          (error) => {
            this.showError("Error fetching Billing Frequencies", error);
            console.error(error);
          }
        );        
      },
      getBillingFrequencyLabel(freq) {
        const descriptions = {
          'MONTHLY': 'Monthly',
          'YEARLY': 'Yearly',
          'TWO_YEARLY': 'Two Yearly',
          'TRIENNIAL': "Three Yearly",
          'ONCE_OFF': "Once-Off"
        };
        return descriptions[freq] || freq;
      },
      deletePackage(number) {
          this.$swal({
              title: "Are you sure you want to delete this Domain Pricing",
              type: "warning",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonText: "Delete"
          }).then((result) => {
              if (result.value) {
                  this.$http.delete(this.$config.aimsAPI + "pricing/domainregistrationpackages/" + number)
                      .then(() => {
                              this.getPackages();
                              this.showSuccess("Delete Success");
                          },
                          (error) => {
                              console.error(error);
                              this.showError("Error Deleting Domain Registration Package", error);
                          }
                      );
              }
          });
      },
      setNewPrice() {
          this.newPrice = this.deepCopyObject(
              this.definition.domainregistrationpackageprice
          );
      },
      openPriceModal(registrationPackage) {
          this.productCurrency = registrationPackage.currency;
          this.rowPrice = this.deepCopyObject(
              registrationPackage.domainregistrationpackageprices || []
          );
          this.newPrice.domainRegistrationPackageNumber =
              registrationPackage.domainRegistrationPackageNumber;
          this.$refs.addDomainPriceModal.open();
      },
      addPrice(newPrice) {
          this.rowPrice.forEach((price) => {
              if (price.validUntil == 0) {
              price.validUntil = this.decreaseBillingPeriod(newPrice.validFrom);
              }
          });
          this.rowPrice.push(newPrice);
          this.setNewPrice();
          this.newPrice.domainRegistrationPackageNumber =
              newPrice.domainRegistrationPackageNumber;
      },
  },
}
</script>

<style>
  .row-expired {
      background-color: #f8f8f8;
  }
</style>
